import { baseApi } from '@/services'

type SlackNotitication = {
  message: string
}

export const slackNotificationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    sendSlackNotification: builder.mutation<SlackNotitication, Partial<SlackNotitication>>({
      query: (body: Partial<SlackNotitication>) => ({
        method: 'POST',
        url: 'slack-notification',
        body,
      }),
      invalidatesTags: ['Snapshot'],
    }),
  }),
})

export const { useSendSlackNotificationMutation } = slackNotificationApi
